export default {"src":"/_next/static/media/logo.1f4d61d5.svg","height":40,"width":170,"blurWidth":0,"blurHeight":0};